import Api from '../api';
const { axios: api } = Api;

const PREFIX = 'feature';

export const loadFeatureConversation = async (payload) => {
	const data = await api.post(`/${PREFIX}/load-conversation`, payload);

	return { data: data?.data };
};

export const getInfoAboutResponseFormat = async (payload) => {
	const data = await api.post(`/${PREFIX}/get-response-format-type`, payload);

	return { data: data?.data };
};

export const loadFeatureConversations = async (payload) => {
	const data = await api.post(`/${PREFIX}/load-conversations`, payload);

	return { data: data?.data };
};

export const getNextMessageFeatureConversation = async (payload) => {
	const data = await api.post(`/${PREFIX}/get-next-message`, payload);

	return { data: data?.data };
};

export const transcriptMessageFeature = async (payload) => {
	const data = await api.post(`/${PREFIX}/transcript`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});

	return { data: data.data };
};

export const generateFeatureVoice = async (payload) => {
	const data = await api.post(`/${PREFIX}/generate-voice`, payload);

	return { data: data?.data };
};

export const deleteFeatureConversation = async (payload) => {
	const data = await api.post(`/${PREFIX}/delete-conversation`, payload);

	return { data: data?.data };
};
